import { render, staticRenderFns } from "./DetailsOne.vue?vue&type=template&id=6a0e0a7e&scoped=true&"
import script from "./DetailsOne.vue?vue&type=script&lang=js&"
export * from "./DetailsOne.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOne.vue?vue&type=style&index=0&id=6a0e0a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e0a7e",
  null
  
)

export default component.exports